export const MenuIdDashboards = 'DASHBOARDS' as const;
